import React, { FunctionComponent } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  LabelList,
} from "recharts";

const data = [
  {
    name: "Week 1",
    uv: 0,
    pv: 0,
  },
  {
    name: "Week 2",
    uv: 0,
    pv: 0,
  },
  {
    name: "Week 3",
    uv: 0,
    pv: 0,
  },
  {
    name: "Week 4",
    uv: 0,
    pv: 0,
  },
  {
    name: "Week 5",
    uv: 0,
    pv: 0,
  },
];

const CustomizedAxisTick: FunctionComponent<any> = (props: any) => {
  const { x, y, payload } = props;

  return (
    <g transform={`translate(${x},${y})`}>
      {/* Add a circle marker for every indicator */}
      <circle cx={0} cy={-8} r={4} fill="#CBCBCB" />
      <text x={0} y={0} dy={16} textAnchor="middle" fontSize={10} fill="#666">
        {payload.value}
      </text>
    </g>
  );
};

export default function Chart(props) {
  const { list } = props;
  const Final = list?.map((item) => {
    if (!item.name) {
      return { name: `week ${item.week}`, ...item };
    } else {
      return item;
    }
  });

  return (
    <LineChart
      className="recharts-surface"
      width={500}
      height={310}
      data={Final ? Final : data}
      margin={{
        top: 50,
        right: 30,
        left: 0,
        bottom: 10,
      }}
    >
      <CartesianGrid />
      <XAxis
        dataKey="name"
        height={60}
        stroke="grey"
        tick={<CustomizedAxisTick />}
      />
      <YAxis axisLine={false} fontSize={10} allowDataOverflow={true} />
      <Tooltip />
      {/* <Legend /> */}
      <Line
        type="monotone"
        dataKey={Final ? "previousMonth" : "pv"}
        stroke="#6842D9"
        strokeWidth="2px"
        dot={false}
      />
      <Line
        type="monotone"
        dataKey={Final ? "thisMonth" : "uv"}
        stroke="#1877F2"
        strokeWidth="2px"
        dot={false}
      />
    </LineChart>
  );
}
